import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import lodash from 'lodash';
import { useTranslation } from 'react-i18next';

import FetchModule from '../../../../Model/Network/FetchModule';

import CrownIcon from '../../../../Image/CrownIcon.png';
import FirstPlaceImg from '../../../../Image/FirstPlace.png';
import SecondPlaceImg from '../../../../Image/SecondPlace.png';
import ThirdPlaceImg from '../../../../Image/ThirdPlace.png';
import RightImg from '../../../../Image/NotAvailableRight.png';
import NoneProfile from '../../../../Image/NoneProfile.png';


export default function RankingPage() {

  const { t } = useTranslation();

  // const eventId = 37;
  const params = useParams();
  const navigate = useNavigate();

  const [tournamentTitle, setTournamentTitle] = useState('');
  const [eventTitle, setEventTitle] = useState('');
  
  const [organizerColumns, setOrganizerColumns] = useState([]);
  const [eventColumns, setEventColumns] = useState([]);
  const [viewEventColumns, setViewEventColumns] = useState([]);

  const [clickedOrganizerId, setClickedOragnizerId] = useState(0);
  const [clickedEventId, setClickedEventId] = useState(0);

  const [columns, setColumns] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [clickedScoreRuleId, setClickedScoreRuleId] = useState(-1);
  const [clickedSelectOptionId, setClickedSelectOptionId] = useState(0);
  const [myRank, setMyRank] = useState(undefined);
  const [ranks, setRanks] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const MyRankBelongRef = useRef();
  const RankBelongRef = useRef([]);


  useEffect(() => {
    let organizerId = params.organizerId;
    let eventId = params.eventId;

    setClickedOragnizerId(parseInt(organizerId));
    setClickedEventId(parseInt(eventId));
  }, [params])

  // let isLastest = true;

  //   setIsYearLoading(true);

  //   if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {
  //     setIsOpenPartnerGymSales(true);

  //     let requestData = {
  //       standardYear: today.format('YYYY') + '-01-01T00:00:00'
  //     }

  //     const fetchModule = new FetchModule();
  //     (
  //       async () => {
  //         const responseData = await fetchModule.postDataVersion2('sales/history/year', 'POST', requestData);
  //         // console.log(responseData.data);
  //         if (responseData.status === 200) {
  //           if (isLastest) {
  //             setYearSalesData(responseData.data);
  //           }
  //         }
  //         else if (responseData.status !== 204) {
  //           if (isLastest) {
  //             setYearSalesData([]);
  //           }
  //         }
  //       }
  //     )();
  //   }
  //   else {
  //     if (selectedPartnerGym.isOpenPartnerGymSales) {
  //       let requestData = {
  //         storeId: selectedPartnerGym.storeId,
  //         standardYear: today.format('YYYY') + '-01-01T00:00:00'
  //       }

  //       const fetchModule = new FetchModule();
  //       (
  //         async () => {
  //           const responseData = await fetchModule.postDataVersion2('sales/history/year/partner_gym', 'POST', requestData);

  //           if (responseData.status === 200) {
  //             if (isLastest) {
  //               setYearSalesData(responseData.data);
  //             }
  //           }
  //           else if (responseData.status === 201) {
  //             if (isLastest) {
  //               setIsOpenPartnerGymSales(false);
  //               setYearSalesData([]);
  //             }
  //           }
  //           else if (responseData.status !== 204) {
  //             if (isLastest) {
  //               setYearSalesData([]);
  //             }
  //           }
  //         }
  //       )();
  //     }
  //     else {
  //       if (isLastest) {
  //         setYearSalesData([]);
  //         setIsOpenPartnerGymSales(false);
  //       }
  //     }
  //   }

  //   return () => {
  //     isLastest = false;
  //   }

  // Event Column API Call //
  useEffect(() => {
    if (clickedOrganizerId === 0) return;
    // const fetchModule = new FetchModule();
    // (
    //   async () => {

    //     const responseData = await fetchModule.getDataOfEventVer2('wod_record/column/' + params.organizerId, 'GET');

    //     if (responseData.status === 200) {
    //       // console.log(responseData.data);
    //       setOrganizerColumns(responseData.data.organizerColumns);
    //       setEventColumns(responseData.data.events);
    //     }
    //   }
    // )();
    let isLastest = true;

    const fetchModule = new FetchModule();
    (
      async () => {

        const responseData = await fetchModule.getDataOfEventVer2('wod_record/column/' + clickedOrganizerId, 'GET');
        // console.log('==========');
        // console.log(responseData);
        if (responseData.status === 200) {
          // console.log(responseData.data);
          if (isLastest) {
            setOrganizerColumns(responseData.data.organizerColumns);
            setEventColumns(responseData.data.events);

            let newViewEventColumns = [];

            for (let i = 0; i < responseData.data.events.length; i++) {
              if (responseData.data.events[i].organizerId === clickedOrganizerId) {
                if (responseData.data.events[i].eventId !== 170
                  && responseData.data.events[i].eventId !== 177
                  && responseData.data.events[i].eventId !== 178
                  && responseData.data.events[i].eventId !== 179
                  && responseData.data.events[i].eventId !== 180
                  && responseData.data.events[i].eventId !== 181
                )
                newViewEventColumns.push(responseData.data.events[i]);
              }
            }

            setViewEventColumns(newViewEventColumns);
          }
        }
      }
    )();

    return () => {
      isLastest = false;
    }
  }, [clickedOrganizerId])

  // Event Column API Call //
  useEffect(() => {
    // console.log(clickedEventId);
    if (clickedEventId === 0) return;
    // const fetchModule = new FetchModule();
    // (
    //   async () => {

    //     const responseData = await fetchModule.getDataOfEventVer2('wod_record/rank/column/' + params.eventId, 'GET');

    //     if (responseData.status === 200) {
    //       if (responseData.data.columns.length > 0) setClickedScoreRuleId(responseData.data.columns[0].scoreRuleId);
    //       if (responseData.data.selectOptions.length > 0) setClickedSelectOptionId(responseData.data.selectOptions[0].selectOptionId);

    //       setTournamentTitle(responseData.data.tournamentTitle);
    //       setEventTitle(responseData.data.eventTitle);
    //       setDivisions(responseData.data.selectOptions);
    //       setColumns(responseData.data.columns);
    //     }
    //   }
    // )();
    // console.log(clickedEventId);
    let isLastest = true;

    const fetchModule = new FetchModule();
    (
      async () => {

        const responseData = await fetchModule.getDataOfEventVer2('wod_record/rank/column/' + clickedEventId, 'GET');
    // console.log(responseData);
        if (responseData.status === 200) {
          if (isLastest) {
            if (responseData.data.columns.length > 0) setClickedScoreRuleId(responseData.data.columns[0].scoreRuleId);
            if (responseData.data.selectOptions.length > 0) setClickedSelectOptionId(responseData.data.selectOptions[0].selectOptionId);
            else setClickedSelectOptionId(0);

            setTournamentTitle(responseData.data.tournamentTitle);
            setEventTitle(responseData.data.eventTitle);
            setDivisions(responseData.data.selectOptions);
            setColumns(responseData.data.columns);
          }
        }
      }
    )();

    return () => {
      isLastest = false;
    }
  }, [clickedEventId])

  // 순위 결과 불러오기 //
  useEffect(() => {
    if (clickedScoreRuleId === -1) return;
    
    let isLastest = true;

    // 전체 순위 //
    if (clickedScoreRuleId === 0) {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.getDataOfEventVer2('wod_record/rank/total/' + clickedEventId, 'GET');
          // console.log(responseData.data);
          if (responseData.status === 200) {
            if (isLastest) {
              setMyRank(responseData.data.myRank);
    
              if (clickedSelectOptionId === 0) setRanks(responseData.data.ranks);
              else {
                let rankData = responseData.data.ranks.slice();
                let finalRank = [];
    
                for (let i = 0; i < rankData.length; i++) {
                  if (rankData[i].selectOptionId === clickedSelectOptionId) {
                    finalRank.push(rankData[i]);
                  }
                }
    
                setRanks(finalRank);
              }

              setIsLoading(false);
            }
          }
          else {
            alert('순위 산출에 실패했습니다\n잠시 후 다시시도해주세요');
            setIsLoading(false);
          }
        }
      )();
    }
    // 세션별 순위 //
    else {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.getDataOfEventVer2('wod_record/rank/' + clickedScoreRuleId, 'GET');
          // console.log(responseData.data);
          if (responseData.status === 200) {
            if (isLastest) {
              setMyRank(responseData.data.myRank);
    
              if (clickedSelectOptionId === 0) setRanks(responseData.data.ranks);
              else {
                let rankData = responseData.data.ranks.slice();
                let finalRank = [];
    
                for (let i = 0; i < rankData.length; i++) {
                  if (rankData[i].selectOptionId === clickedSelectOptionId) {
                    finalRank.push(rankData[i]);
                  }
                }
                
                setRanks(finalRank);
              }
              setIsLoading(false);
            }
          }
          else {
            alert('순위 산출에 실패했습니다\n잠시 후 다시시도해주세요');
            setIsLoading(false);
          }
        }
      )();
    }

    return () => {
      isLastest = false;
    }
  }, [clickedEventId, clickedScoreRuleId, clickedSelectOptionId])

  // Message Detect Save And Delete //
  useEffect(() => {
    // Android //
    document.addEventListener('message', handleMassage);

    // IOS //
    window.addEventListener('message', handleMassage);

    return () => {
      // Android //
      document.removeEventListener('message', handleMassage);

      // IOS //
      window.removeEventListener('message', handleMassage);
    }
  }, [])

  // 페이지 이름 변경내역 업로드 //
  useEffect(() => {
    try {
      window.ReactNativeWebView.postMessage(JSON.stringify({ pageName: t('순위표'), isAvailableGoback: false }));
    }
    catch (e) {
      console.log("Web Message Post Error : " + e);
    }
  }, []);

  // React Native에서 웹으로 보내는 데이터 handler //
  async function handleMassage(e) {
    let responseData = JSON.parse(e.data);

    if (responseData.goBack) {
      await window.localStorage.removeItem('GenderDivision');
      navigate(-1);
    }
  }

  // 컬럼 텍스트 정리 //
  function decideColumnText(data) {
    let isExist = false;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].wodId === data.wodId
        && (columns[i].scoreRuleViewIndex !== 1)) {
        isExist = true;
        break;
      }
    }

    if (isExist) return data.wodSubTitle + '-' + String.fromCharCode(64 + data.scoreRuleViewIndex);
    else return data.wodSubTitle;
  }

  // 구분 너비 정리 //
  function decideDivisionWidth() {
    return (100 / divisions.length);
  }

  // 구분 데이터 텍스트 //
  function decideDivisionText(data) {
    return data.name;
  }

  // 전체 순위 등수표 결정 //
  function decidePlacement(data) {
    if (data.wodRecordId === 0 && clickedScoreRuleId !== 0) {
      return (
        <RankingNumberBox>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF'>{ranks.length}</Text>
        </RankingNumberBox>
      )
    }
    else {
      let rankImage = FirstPlaceImg;

      if (data.rank === 1) rankImage = FirstPlaceImg;
      else if (data.rank === 2) rankImage = SecondPlaceImg;
      else if (data.rank === 3) rankImage = ThirdPlaceImg;

      if (data.rank < 4) {
        return (
          <RankingLeaderBoxWrapper>
            <RankingLeaderBox src={rankImage} />
            <RankingImageTextWrapper>
              <Text style={{ marginTop: `-8px` }} fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF'>{data.rank}</Text>
            </RankingImageTextWrapper>
          </RankingLeaderBoxWrapper>
        )
      }
      else {
        return (
          <RankingNumberBox>
            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF'>{data.rank}</Text>
          </RankingNumberBox>
        );
      }
    }
  }
  
  const formatTime = (min, sec, milliSec) => {
    const paddedMin = String(min ?? 0).padStart(2, '0');
    const paddedSec = String(sec ?? 0).padStart(2, '0');
    const paddedMilliSec = String(milliSec ?? 0).padStart(2, '0');

    if (paddedMilliSec === '00') return `${paddedMin}:${paddedSec}`;
    else return `${paddedMin}:${paddedSec}.${paddedMilliSec}`;
  };

  const getScoreValue = (record, isTieBreak = false) => {
    const prefix = isTieBreak ? 'finalTieBreak' : 'final';
    const keyword = isTieBreak ? record.tieBreakScoreKeyword : record.scoreKeyword;
    const tag = isTieBreak ? record.tieBreakTag : record.tag;
    const isUseTimeCap = isTieBreak ? record.tieBreakIsUseTimeCap : record.isUseTimeCap;
    const isSuccess = isTieBreak ? record.finalTieBreakIsSuccess : record.finalIsSuccess;
  
    // ForTime + TimeCap + 실패한 경우 → Rounds + Reps 형식으로 표시
    if (tag === 'ForTime' && isUseTimeCap && !isSuccess) {
      const round = record[`${prefix}Round`] ?? 0;
      const reps = record[`${prefix}Reps`] ?? 0;
  
      return (
        <RecordTextWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#4F4F4F'>{round}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>R</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#4F4F4F'>{reps}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>Reps</Text>
        </RecordTextWrapper>
      );
    }
  
    // AMRAP 또는 Rounds + Reps
    if (tag === 'AMRAP' || keyword === 'Rounds + Reps') {
      const round = record[`${prefix}Round`] ?? 0;
      const reps = record[`${prefix}Reps`] ?? 0;
  
      return (
        <RecordTextWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#4F4F4F'>{round}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>R</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#4F4F4F'>{reps}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>Reps</Text>
        </RecordTextWrapper>
      );
    }
  
    // ForTime or Time (성공한 경우만 시간 표시)
    if ((tag === 'ForTime' || keyword === 'Time')) {
      const min = record[`${prefix}Min`];
      const sec = record[`${prefix}Sec`];
      const milliSec = record[`${prefix}MilliSec`];

      return formatTime(min, sec, milliSec);
    }
  
    if (['Peek Watt', 'Max Speed', 'Distance', 'Weight', 'Point'].includes(keyword)) {
      return `${record[`${prefix}CustomValue`] ?? ''}`;
    }
    if (keyword === 'Reps') {
      return `${record[`${prefix}Reps`] ?? ''}`;
    }
  
    return '';
  };
  

  const getScoreLabel = (tag, keyword, isUseTimeCap, isSuccess) => {
    if (tag === 'ForTime') {
      // 시간 제한이 있고 실패했을 경우 → 라벨 없음
      if (isUseTimeCap && !isSuccess) return '';
      return 'Time';
    }
  
    if (tag === 'AMRAP') return '';
  
    switch (keyword) {
      case 'Time':
        return 'Time';
      case 'Reps':
        return 'Reps';
      case 'Rounds + Reps':
        return '';
      case 'Distance':
        return 'm';
      case 'Weight':
        return 'lb';
      case 'Point':
        return 'Point';
      case 'Peek Watt':
        return 'Watt';
      case 'Max Speed':
        return 'Speed';
      case 'Not Scored':
        return '';
      default:
        return '';
    }
  };

  // 전체 순위 산출시 기록 표출 //
  function decideRecordView(data) {
    if (data.wodRecordId === 0) {
      return (
        <RecordTextWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#4F4F4F'>{t('미제출')}</Text>
        </RecordTextWrapper>
      )
    }
    else {
      const mainScore = getScoreValue(data);
      const mainLabel = getScoreLabel(data.tag, data.scoreKeyword, data.isUseTimeCap, data.finalIsSuccess);
      const tieBreakScore = data.isUseTieBreak ? getScoreValue(data, true) : '';
      const tieBreakLabel = data.isUseTieBreak ? 'TieBreak' : '';
  
      return (
        <RecordTextWrapper>
          {
            (data.tag === 'AMRAP' || data.scoreKeyword === 'Rounds + Reps') ?
              mainScore
              :
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#4F4F4F'>{mainScore}</Text>
          }
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>{mainLabel}</Text>
          {
            (data.tieBreakTag === 'AMRAP' || data.tieBreakScoreKeyword === 'Round + Reps') ?
              tieBreakScore
              :
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#4F4F4F'>{tieBreakScore}</Text>
          }
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>{tieBreakLabel}</Text>
        </RecordTextWrapper>
      )
    }
  }

  // 전체 순위 산출시 기록 표출 //
  function decideTotalRecordView(data) {
    // 시간·포인트 합산으로 종합 순위를 내는 대회는 총 시간을 함께 표출한다 //
    if (data.totalRecordMin !== undefined && data.totalRecordMin !== null) {
      return (
        <RecordTextWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#4F4F4F'>{formatTime(data.totalRecordMin, data.totalRecordSec, data.totalRecordMilliSec)}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>Time</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#4F4F4F'>{data.point}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>Point</Text>
        </RecordTextWrapper>
      )
    }

    return (
      <RecordTextWrapper>
        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#4F4F4F'>{data.point}</Text>
        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#BDBDBD'>Point</Text>
      </RecordTextWrapper>
    )
  }
  
  // 내순위 팀 구성원 자세히보기 클릭시 //
  function onClickMyRecordDetailButton(e) {
    // if (e.target === MyRankBelongRef.current || MyRankBelongRef.current.contains(e.target)) return;

    let data = lodash.cloneDeep(myRank);

    if (clickedScoreRuleId !== 0 && 
      (data.members === undefined || data.members.length === 0)) return;
    
    if (data.isClicked === undefined) data.isClicked = true;
    else data.isClicked = !data.isClicked;
    
    setMyRank(data);
  }

  // 팀 구성원 자세히보기 클릭시 //
  function onClickRecordDetailButton(e, data, index) {
    if (clickedScoreRuleId !== 0 
      && (data.members === undefined || data.members.length === 0)) return;

    // if (e.target === RankBelongRef.current[index] || RankBelongRef.current[index].contains(e.target)) return;

    let dates = ranks.slice();

    for (let i = 0; i < dates.length; i++) {
      if (i !== index) dates[i].isClicked = false;
    }

    dates[index].isClicked = !dates[index].isClicked;

    setRanks(dates);
  }

  // 최종 순위표 내의 순위 산출시 배경색 결정 //
  function selectTotalEventRankingBoxBackgroundColor(data) {
    if (clickedScoreRuleId === 0 && data === undefined) return '#E0E0E0';
    else if (data.rank === 1) return '#FEB501';
    else if (data.rank === 2) return '#94B1C1';
    else if (data.rank === 3) return '#F38D30';
    else return '#E0E0E0';
  }
  
  // 랭킹 세션 변경 클릭시 //
  function onClickScoreRuleId(value) {
    setIsLoading(true);
    setMyRank(undefined);
    setRanks([]);
    setClickedScoreRuleId(value);
  }

  // 랭킹 세션 구분 변경 클릭시 //
  function onClickSelectOptionId(value) {
    setIsLoading(true);
    setMyRank(undefined);
    setRanks([]);
    setClickedSelectOptionId(value);
  }

  // 이벤트 큰단락 클릭시 //
  function onClickOrganizerColumn(data) {
    const target = eventColumns.find(col => col.organizerId === data.organizerId);
    const eventId = target?.eventId ?? 0;

    navigate('/rank/' + data.organizerId + '/' + eventId);
  }

  // 이벤트 작은 단락 클릭시 //
  function onClickEventColumn(data) {
    navigate('/rank/' + clickedOrganizerId + '/' + data.eventId);
  }

  // 소속 클릭시 //
  function onClickBelong(belong) {
    // navigate('/belong/' + belong)
    // console.log(belong);
    // let requestData = {
    //   storeName: belong
    // }

    // const fetchModule = new FetchModule();
    // (
    //   async () => {
    //     const responseData = await fetchModule.postDataOfZoneVer2('store/search', 'POST', requestData);
    //     console.log(responseData);
    //     if (responseData.status === 200) {

    //     }
    //   }
    // )();
  }

  return (
    <TopLevelWrapper>
      <TopLineWrapper>
        <TitleWrapper>
          <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#333333'>{tournamentTitle}</Text>
        </TitleWrapper>
      </TopLineWrapper>
      <DivisionLine />
      {
        organizerColumns.length > 1 &&
        <SectionButtonWrapper>
          {
            organizerColumns.map((data, index) => (
              <SectionButton
                key={'OrganizerColumn-' + index}
                isClicked={clickedOrganizerId === data.organizerId}
                onClick={() => onClickOrganizerColumn(data)}>
                <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF'>{data.columnText === '' ? data.title : data.columnText}</Text>
              </SectionButton>
            ))
          }
        </SectionButtonWrapper>
      }
      {/* {
        eventColumns.length > 1 && 
        <SectionButtonWrapper>
          {
            eventColumns.map((data, index) => (
              <SectionButton
                key={'TicketColumn-' + index}
                isClicked={clickedEventId === data.eventId}
                onClick={() => onClickEventColumn(data)}>
                <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF'>{data.eventTitle}</Text>
              </SectionButton>
            ))
          }
        </SectionButtonWrapper>
      } */}
      {
        viewEventColumns.length > 1 && 
        <SectionButtonWrapper>
          {
            viewEventColumns.map((data, index) => (
              <SectionButton
                key={'TicketColumn-' + index}
                isClicked={clickedEventId === data.eventId}
                onClick={() => onClickEventColumn(data)}>
                <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF'>{data.eventTitle}</Text>
              </SectionButton>
            ))
          }
        </SectionButtonWrapper>
      }
      <SectionButtonWrapper>
        {
          columns.map((data, index) => (
            <SectionButton
              key={'EventColumn-' + index}
              isClicked={clickedScoreRuleId === data.scoreRuleId}
              onClick={() => onClickScoreRuleId(data.scoreRuleId)}>
              <Text fontFamily='Poppins-Bold' fontSize={14} color='#FFFFFF'>{decideColumnText(data)}</Text>
            </SectionButton>
          ))
        }
        <TotalSection isClicked={clickedScoreRuleId === 0} onClick={() => onClickScoreRuleId(0)}>
          <CrownImage src={CrownIcon} />
        </TotalSection>
      </SectionButtonWrapper>
      {
        divisions.length > 0 &&
        <DivisionSelectWrapper>
          {
            divisions.map((data, index) => (
              <DivisionSelectBox
                key={'Division-' + index}
                width={decideDivisionWidth()}
                isClicked={clickedSelectOptionId === data.selectOptionId}
                onClick={() => onClickSelectOptionId(data.selectOptionId)}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={15} color='#FFFFFF'>{decideDivisionText(data)}</Text>
              </DivisionSelectBox>
            ))
          }
        </DivisionSelectWrapper>
      }
      <DivisionLine />
      {
        <TotalWrapper>
          {
            (myRank !== undefined) &&
            <TempWrapper>
              <TopLineWrapper>
                <TitleWrapper>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={16} color='#333333'>{t('내 순위')}</Text>
                </TitleWrapper>
              </TopLineWrapper>
              {
                isLoading ?
                  <RankingTotalWrapper>
                    <RankingLoadingView>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#4F4F4F'>{t('순위 계산중...')}</Text>
                    </RankingLoadingView>
                  </RankingTotalWrapper>
                  :
                  <RankingTotalWrapper>
                    <RankingViewWrapper onClick={() => onClickMyRecordDetailButton(myRank)}>
                      <RankingNumberBoxWrapper>{decidePlacement(myRank)}</RankingNumberBoxWrapper>
                      <RankingClickBoxWrapper>
                        <RankingClickBox isClicked={myRank.isClicked ?? false} >
                          <InfoBox>
                            <LeftWrapper>
                              <Profile src={myRank.profile === '' ? NoneProfile : myRank.profile} />
                              <InfoTextWrapper style={{ marginLeft: '8px' }}>
                                <InnerInfoTextWrapper>
                                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#333333'>{myRank.name}</Text>
                                </InnerInfoTextWrapper>
                                <RecordBox>{clickedScoreRuleId === 0 ? decideTotalRecordView(myRank) : decideRecordView(myRank)}</RecordBox>
                              </InfoTextWrapper>
                            </LeftWrapper>
                            { myRank.members.length > 0 && <DetailButton isClicked={myRank.isClicked ?? false} src={RightImg} />}
                          </InfoBox>
                          <MemberRowView isClicked={myRank.isClicked ?? false}>
                            {
                              myRank.members.map((data, index) => (
                                <MemberView key={'MyRankMembers-' + index}>
                                  <MemberProfile src={data.profile === '' ? NoneProfile : data.profile} />
                                  <ColorBoxWrapper>
                                    <ColorBox backgroundColor={data.gender === 'male' ? '#2F80ED' : '#FF3131'}>
                                      <ScaleText fontFamily='NotoSansKR-Medium' fontSize={10} scale={0.8} color='#FFFFFF'>ATHLETE</ScaleText>
                                    </ColorBox>
                                    <ColorBoxInTextWrapper>
                                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#333333'>{data.name}</Text>
                                    </ColorBoxInTextWrapper>
                                  </ColorBoxWrapper>
                                </MemberView>
                              ))
                            }
                          </MemberRowView>
                          <BottomLine ref={MyRankBelongRef} onClick={() => onClickBelong(myRank.belong)}>
                            <Text fontFamily='NotoSansKR-Thin' fontSize={14} color='#4F4F4F'>Team : </Text>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#4F4F4F'>{myRank.belong}</Text>
                          </BottomLine>
                        </RankingClickBox>
                        {
                          <TotalRecordWrapper isClicked={(myRank.isClicked ?? false) && clickedScoreRuleId === 0}>
                             {
                              myRank.totalRanks.map((rank, rankIndex) => (
                                <EventRowWrapper 
                                  key={'TotalRankDetail-' + rankIndex}
                                  style={{ marginTop: '4px' }}>
                                  <EventBox>
                                    <ScaleText fontFamily='Poppins-Bold' fontSize={10} color='#FFFFFF' scale={1}>{decideColumnText(rank)}</ScaleText>
                                  </EventBox>
                                  <EventRankingBox backgroundColor={selectTotalEventRankingBoxBackgroundColor(rank)}>
                                    <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF'>{decidePlacement(rank)}</Text>
                                  </EventRankingBox>
                                  <EventInfoBox>
                                    <RecordBox>{decideRecordView(rank)}</RecordBox>
                                  </EventInfoBox>
                                </EventRowWrapper>
                              ))
                            }
                          </TotalRecordWrapper>
                        }
                      </RankingClickBoxWrapper>
                    </RankingViewWrapper>
                  </RankingTotalWrapper>
              }
            </TempWrapper>
          }
          <TopLineWrapper>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={16} color='#333333'>{t('전체 순위')}</Text>
            </TitleWrapper>
          </TopLineWrapper>
          {
            isLoading ?
              <RankingTotalWrapper>
                <RankingLoadingView>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#4F4F4F'>{t('순위 계산중...')}</Text>
                </RankingLoadingView>
              </RankingTotalWrapper>
              :
              <RankingTotalWrapper>
                {
                  ranks.map((data, index) => (
                    <RankingViewWrapper key={'TotalRank-' + index} onClick={(e) => onClickRecordDetailButton(e, data, index)}>
                      <RankingNumberBoxWrapper>{decidePlacement(data)}</RankingNumberBoxWrapper>
                      <RankingClickBoxWrapper>
                        <RankingClickBox isClicked={data.isClicked}>
                          <InfoBox>
                            <LeftWrapper>
                              <Profile src={data.profile === '' ? NoneProfile : data.profile} />
                              <InfoTextWrapper style={{ marginLeft: '8px' }}>
                                <InnerInfoTextWrapper>
                                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#333333'>{data.name}</Text>
                                </InnerInfoTextWrapper>
                                <RecordBox>{clickedScoreRuleId === 0 ? decideTotalRecordView(data) : decideRecordView(data)}</RecordBox>
                              </InfoTextWrapper>
                            </LeftWrapper>
                            { data.members.length > 0 && <DetailButton isClicked={data.isClicked} src={RightImg} /> }
                          </InfoBox>
                          <MemberRowView isClicked={data.isClicked}>
                            {
                              data.members.map((innerData, index) => (
                                <MemberView key={index}>
                                  <MemberProfile src={innerData.profile === '' ? NoneProfile : innerData.profile} />
                                  <ColorBoxWrapper>
                                    <ColorBox backgroundColor={innerData.gender === 'male' ? '#2F80ED' : '#FF3131'}>
                                      <ScaleText fontFamily='NotoSansKR-Medium' fontSize={10} scale={0.8} color='#FFFFFF'>ATHLETE</ScaleText>
                                    </ColorBox>
                                    <ColorBoxInTextWrapper>
                                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#333333'>{innerData.name}</Text>
                                    </ColorBoxInTextWrapper>
                                  </ColorBoxWrapper>
                                </MemberView>
                              ))
                            }
                          </MemberRowView>
                          <BottomLine ref={element => (RankBelongRef.current[index] = element)} onClick={() => onClickBelong(data.belong)}>
                            <Text fontFamily='NotoSansKR-Thin' fontSize={14} color='#4F4F4F'>Team : </Text>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#4F4F4F'>{data.belong}</Text>
                          </BottomLine>
                        </RankingClickBox>
                        {
                          <TotalRecordWrapper isClicked={data.isClicked && clickedScoreRuleId === 0}>
                            {
                              data.totalRanks.map((rank, rankIndex) => (
                                <EventRowWrapper 
                                  key={'TotalRankDetail-' + rankIndex}
                                  style={{ marginTop: '4px' }}>
                                  <EventBox>
                                    <ScaleText fontFamily='Poppins-Bold' fontSize={10} color='#FFFFFF' scale={0.8}>{decideColumnText(rank)}</ScaleText>
                                  </EventBox>
                                  <EventRankingBox backgroundColor={selectTotalEventRankingBoxBackgroundColor(rank)}>
                                    <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF'>{decidePlacement(rank)}</Text>
                                  </EventRankingBox>
                                  <EventInfoBox>
                                    <RecordBox>{decideRecordView(rank)}</RecordBox>
                                  </EventInfoBox>
                                </EventRowWrapper>
                              ))
                            }
                          </TotalRecordWrapper>
                        }
                      </RankingClickBoxWrapper>
                    </RankingViewWrapper>
                  ))
                }
              </RankingTotalWrapper>
          }
        </TotalWrapper>
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding-bottom: 80px;

  width: 100%;
  height: 100%;

  min-height: 100vh;

  background-color: #F9F9F9;
`;

const TopLineWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 90.33%; 
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 20px;

  width: 100%;
`;

const SectionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  flex-wrap: wrap;
  
  width: 90.33%;
`;

const SectionButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;
  margin-top: 10px;
  margin-right: 8px;

  height: 32px;

  border-radius: 6px;
  background-color: ${props => props.isClicked ? `#6DD49E` : `#E0E0E0`};

  :hover {
    cursor: pointer;
  }
  
  transition: all 0.3s ease-in-out;
`;

const TotalSection = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 10px;

  width: 32px;
  height: 32px;

  border-radius: 6px;
  background-color: ${props => props.isClicked ? `#FF8B48` : `#E0E0E0`};

  :hover {
    cursor: pointer;
  }
  
  transition: all 0.3s ease-in-out;
`;

const DivisionLine = styled.div`
  width: 90.33%;
  height: 1px;

  // margin: 20px 0px 20px 0px;
  margin: 20px 0px 10px 0px;

  background-color: #E0E0E0;
`;

const DivisionSelectWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 15px;

  width: 100%;
`;

const DivisionSelectBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;

  width: ${props => props.width}%;
  height: 32px;

  border-radius: 10px 10px 0px 0px;
  background-color: ${props => props.isClicked ? '#FFB800' : '#E0E0E0'};

  transition: all 0.3s ease-in-out;
`;

const GenderImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  transition: all 0.3s ease-in-out;
`;

const GenderImage = styled.img`
  width: 11px;
  height: 20px;

  transition: all 0.3s ease-in-out;
`;

const CrownImage = styled.img`
  width: 22px;
  height: 19px;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;  

  width: 100%;
`;

const TempWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;  

  width: 100%;
`;

const RankingTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
  
  // margin: 4px 0px 80px 0px;
  marigin-top: 4px;

  width: 90.33%;
`;

const RankingLoadingView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 12px;

  width: 100%;
  height: 64px;
`;

const RankingViewWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 12px;

  width: 100%;
  // height: 64px;
  // height: ${props => props.height}px;
  height: auto;

  transition: all 0.3s ease-in-out;
`;

const RankingNumberBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const RankingLeaderBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const RankingLeaderBox = styled.img`
  width: 40px;
  height: 40px;
`;

const RankingImageTextWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  // margin-top: -10px;
`;

const RankingNumberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;

  border-radius: 12px;
  background-color: #E0E0E0;
`;

const RankingClickBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: calc(100% - 44px);
`;

const RankingClickBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: center;

  padding: 0px 16px 0px 12px;

  width: calc(100% - 28px);
  height: ${props => props.isClicked ? `auto` : `64px`};

  overflow: hidden;
  
  border-radius: 12px;
  background-color: #FFFFFF;

  box-shadow: 0px 10px 10px rgba(0, 54, 71, 0.02), 0px 14px 32px rgba(0, 54, 71, 0.05);

  :hover {
    cursor: pointer;
    background-color: #F9F9F9;
  }

  transition: all 0.3s ease-in-out;
`;

const BottomLine = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 4px;
  gap: 4px;

  width: calc(100% + 30px);
  height: 25px;
  
  background-color: #F2F2F2;
`;

const TotalRecordWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: ${props => props.isClicked ? 10 : 0}px;

  width: 100%;
  height: ${props => props.isClicked ? 'auto' : '0px'};

  overflow: hidden;

  opacity: ${props => props.isClicked ? 1 : 0};
  
  transition: all 0.6s ease-in-out;
`;

const EventRowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;
`;

const EventBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;

  // border-radius: 7px;
  border-radius: 12px 0px 0px 12px;
  background-color: #C4C4C4;
`;

const EventInfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 0px 0px 8px;

  width: calc(85.27% - 48px);
  height: 40px;

  border-radius: 8px;
  background-color: #FFFFFF;
`;

const EventRankingBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;

  // border-radius: 12px;
  border-radius: 0px 12px 12px 0px;
  background-color: ${props => props.backgroundColor};
`;

const EventInfoTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-end;

  margin-left: 8px;

  height: 20px;
`;

const TotalInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const MemberRowView = styled.div`
  display: flex;
  flex-direction: row;

  flex-wrap: wrap;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: auto;

  opacity: ${props => props.isClicked ? 1 : 0};

  transition: all 0.6s ease-in-out;
`;

const MemberView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 12px;
`;

const MemberProfile = styled.img`
  width: 40px;
  height: 40px;

  margin-right: 8px;

  border-radius: 6px;

  object-fit: contain;
`;

const ColorBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const ColorBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 41px;
  height: 21px;

  border-radius: 4px;
  background-color: ${props => props.backgroundColor};
`;

const ColorBoxInTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 41px;
  height: 20px;
  
  overflow: hidden;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  // margin-top: 12px;

  width: 100%;
  min-height: 64px;
  height: 64px;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  // gap: 8px;
`;

const Profile = styled.img`
  width: 40px;
  height: 40px;

  border-radius: 6px;
`;

const InfoTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const InnerInfoTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 6px;
`;

const RecordBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const RecordTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const DetailButton = styled.img`
  width: 9.6px;
  height: 17.7px;

  transform: ${props => props.isClicked ? `rotateZ(90deg)` : `rotateZ(0deg)`};

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: default;
  }

  transition: all 0.3s ease-in-out;
`;

const ScaleText = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: default;
  }
  
  -webkit-transform: scale(${props => props.scale});
  transition: all 0.3s ease-in-out;
`;

const WaitWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 74px;
`;

const WaitImage = styled.img`
  width: 148px;
  height: 62px;

  :hover {
    cursor: default;
  }
`;